import { REGIONS } from 'shared/constants';

const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'ENUM',
    key: 'region',
    label: 'Region',
    options: REGIONS
  }
];

export default {
  id: 'FutureSightLanding',
  name: 'FutureSight Landing',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1503956140000,
  updatedAt: 1503956140000,
  slots,
  templateSettings,
  defaultProps
};
